import React from "react";
import {
  Typography,
  Grid,
  Box,
  Button,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Schedule(props) {
  const {
    state,
    activeStep,
    name,
    provider,
    number_of_trainee,
    description,
    customized_val,
    start_date,
    end_date,
    start_time,
    stop_time,
    depends_on,
    repeat_frequency,
    on_days,
    startcron_expression,
    startcron_expression2,
    budget_credit,
    env_keep_date,
    meeting_url,
    // budgethours,
    // billingtype,
    userEmail,
    // selectedRelatedLabType,
    // selectedMasterLabId,
    handleBack,
    handleSubmitClick,
    stepslength,
  } = props;

  let email;
  if (state.email) {
    email = state.email;
  } else {
    email = localStorage.getItem("email");
  }
  // If you need to use `const`, you can reassign it after determining the value

  // const guacmoleLabState = state.guacmoleLabState ? "yes" : "no";
  const feedback = state.feedbackno && state.selectedDates ? "Yes" : "No";
  const feedBack_date = state.selectedDates;
  const env_keep = state.env_keep ? "yes" : "no";
  const manage_labs =
    state.manageState && state.depends_on === "during_training" ? "yes" : "no";

  var disable_copypaste_guac;
  if (state.disable_copypaste) {
    disable_copypaste_guac = "yes";
  } else {
    disable_copypaste_guac = "no";
  }

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  let parsedVariables = {};
  // console.log("user email information", userEmail);
  try {
    parsedVariables = JSON.parse(customized_val);
  } catch (error) {
    console.error("Error parsing customized_variable:", error);
  }

  const getFormattedDays = (cronExpression) => {
    const cronParts = cronExpression.split(" ");
    const monthNumber = cronParts[cronParts.length - 2]; // Extract month number before '?'
    const monthNames = {
      "1": "Jan",
      "2": "Feb",
      "3": "March",
      "4": "April",
      "5": "May",
      "6": "June",
      "7": "July",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec",
    }; // Add more months if needed
    const month = monthNames[monthNumber] || "Unknown";
    const days = cronParts.slice(2, cronParts.length - 2)[0]?.split(",") || [];
    return days.map((day) => `${month}-${day.trim()}`).join(", ");
  };

  return (
    <div>
      <Card
        style={{
          height: "auto",
          backgroundColor: "#06396c",
          color: "#000000",
          borderRadius: "16px",
          margin: "6px",
          padding: "6px",
          width: "100%",
          maxWidth: "1000px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <CardContent
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
            padding: "0",
          }}
        >
          {/* Lab Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{
                marginBottom: "8px",
                color: "#262626",
                textAlign: "center",
              }}
            >
              Lab Information
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Lab Name:
              </Typography>
              <Typography variant="body1">{name}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Trainees:
              </Typography>
              <Typography variant="body1">{number_of_trainee}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Cloud Provider Selected:
              </Typography>
              <Typography variant="body1">{provider || "N/A"}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Is Admin Access:
              </Typography>
              <Typography variant="body1">
                {parsedVariables.admin ? "Yes" : "No"}
              </Typography>
            </div>
            {state.provider === "Gcp" && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  GCP User Email ID's:
                </Typography>
                <Typography variant="body1">
                  {userEmail.filter((email) => email.trim() !== "").length > 0
                    ? userEmail
                        .filter((email) => email.trim() !== "")
                        .join(", ")
                    : "N/A"}
                </Typography>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Description:
              </Typography>
              <Typography variant="body1">{description || "N/A"}</Typography>
            </div>
          </div>

          {/* Schedule Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{
                marginBottom: "8px",
                color: "#262626",
                textAlign: "center",
              }}
            >
              Schedule Information
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Start Date:
              </Typography>
              <Typography variant="body1">
                {start_date.split("-").reverse().join("-")}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                End Date:
              </Typography>
              <Typography variant="body1">
                {end_date.split("-").reverse().join("-")}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Start Time:
              </Typography>
              <Typography variant="body1">{start_time}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Stop Time:
              </Typography>
              <Typography variant="body1">{stop_time}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Schedule Type:
              </Typography>
              <Typography variant="body1">
                {capitalizeFirstLetter(depends_on)}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Repeat_Frequency:
              </Typography>
              <Typography variant="body1">
                {depends_on === "during_training"
                  ? capitalizeFirstLetter(repeat_frequency)
                  : "N/A"}
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="body1"
                style={{ fontWeight: "bold", marginRight: "10px" }}
              >
                Days:
              </Typography>
              <div>
                {depends_on === "during_training" &&
                repeat_frequency === "day" ? (
                  <>
                    {[
                      ...getFormattedDays(startcron_expression).split(","),
                      ...getFormattedDays(startcron_expression2).split(","),
                    ]
                      .reduce((acc, date, index, arr) => {
                        if (index % 2 === 0) {
                          acc.push(arr.slice(index, index + 2).join(", "));
                        }
                        return acc;
                      }, [])
                      .map((pair, index) => (
                        <Typography key={index} variant="body1">
                          {pair}
                        </Typography>
                      ))}
                  </>
                ) : (
                  <Typography variant="body1">N/A</Typography>
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Weekly on:
              </Typography>
              <Typography variant="body1">
                {depends_on === "during_training" && repeat_frequency === "week"
                  ? on_days
                  : "N/A"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Billing Type:
              </Typography>
              <Typography variant="body1">
                {"Budget"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Budget Credit:
              </Typography>
              <Typography variant="body1">
                {(budget_credit * number_of_trainee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            </div>
          </div>

          {/* Parameters Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{
                marginBottom: "8px",
                color: "#262626",
                textAlign: "center",
              }}
            >
              Parameters Information
            </Typography>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Notification Email:
              </Typography>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {email.split(",").map((emailItem, index) => (
                  <Typography
                    key={index}
                    variant="body1"
                    style={{ display: "block" }}
                  >
                    {emailItem.trim()}
                  </Typography>
                ))}
              </div>
            </div>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Related Lab Information:
              </Typography>
              <Typography variant="body1">{guacmoleLabState === "yes" ? `Lab Type : ${selectedRelatedLabType} | Master Lab Id : ${selectedMasterLabId}`  : "No"}</Typography>
            </div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="body1"
                style={{ fontWeight: "bold", marginRight: "10px" }}
              >
                Feedback:
              </Typography>
              <div>
                {feedback === "Yes" ? (
                  feedBack_date
                    .split(",")
                    .map((date) => date.trim().replace(/\//g, "-")) // Replace '/' with '-'
                    .reduce((acc, date, index, arr) => {
                      if (index % 2 === 0) {
                        acc.push(arr.slice(index, index + 2).join(", "));
                      }
                      return acc;
                    }, [])
                    .map((pair, index) => (
                      <Typography key={index} variant="body1">
                        {pair}
                      </Typography>
                    ))
                ) : (
                  <Typography variant="body1">No</Typography>
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Manage Labs:
              </Typography>
              <Typography variant="body1">
                {manage_labs === "yes" ? manage_labs : "No"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Keep Lab Environment:
              </Typography>
              <Typography variant="body1"></Typography>
              <Typography variant="body1">
                {env_keep === "yes"
                  ? env_keep_date.split("-").reverse().join("-")
                  : "No"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Meeting Url:
              </Typography>
              <Typography
                variant="body1"
                style={{ wordBreak: "break-word", maxWidth: "50%" }}
              >
                {meeting_url !== "" ? meeting_url : "No"}
              </Typography>
            </div>
          </div>
        </CardContent>
        <div>&ensp;</div>
        {/* Accordion Section - Customized Variables */}

        {parsedVariables && Object.keys(parsedVariables).length > 1 && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Limited Access Information</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {Object.entries(parsedVariables)
                    .filter(([key, value]) => !(key === "admin")) // Exclude "admin": false
                    .map(([key, value]) => (
                      <Grid item xs={12} sm={6} md={4} key={key}>
                        <Box border={1} p={2} borderRadius={2}>
                          <Typography variant="subtitle1">
                            <strong>{key}:</strong> {value ? "Yes" : "No"}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
      </Card>

      {/* Buttons outside of the card */}
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Tooltip title="Cancel and reload this review">
          <span>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => window.location.reload()}
              sx={{ borderRadius: '50px' }}
            >
              Cancel
            </Button>
          </span>
        </Tooltip>
        <Box>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} sx={{ mr: 0.5, borderRadius: '50px' }}>
                  Back
                </Button>
              </span>
            </Tooltip>
          )}
          <Tooltip title="Submit your lab deployment request">
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitClick}
                sx={{ borderRadius: '50px' }}
              >
                Create
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Box>
    </div>
  );
}
